import React from 'react';
import { 
	CloseIcon,
	CryptosIcon,
	BondsIcon,
	StocksIcon,
	ArrowRightBlack,
	ArrowLeftBlack
} from 'assets/icons';
import { Colors, Globals, Constants } from 'utils';
import { Select } from 'components';
import { 
	Chart, 
	BarController,
	BarElement,
	LinearScale,
	CategoryScale,
	ArcElement,
	Tooltip as ChartTooltip,
	Legend,
	DoughnutController
} from 'chart.js';
import { MoneyService } from 'services';

Chart.register(
	BarController,
	BarElement,
	LinearScale,
	CategoryScale,
	ArcElement,
	ChartTooltip,
	Legend,
	DoughnutController
);

interface Props {
	onClose: any;
	tab: number;
	user: any;
}

const TABS = {
	PHYSICAL: 1,
	DIGITAL: 2,
	LIQUIDITY: 3,
}

const CHARTS = {
	CIRCLE: 1,
	BARS: 3
}

class ModalView extends React.Component<Props> {

	state = {
		form: {
			category_id: '',
			type: Constants.MONEY_CATEGORIES.STOCKS
		},
		chart: null,
		chart_bars: null,
		categories: [],
		data: [],
		total: 0,
		chart_type: CHARTS.CIRCLE
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		if (this.props.tab == TABS.PHYSICAL) {
			const res: any = await MoneyService.admin.physical.view({
				user_id: this.props.user?.id,
				...this.state.form
			});
			for (let i = 0; i < res.data?.length; i++) {
				if (!res.data[i].color) {
					const hue = (i * (360 / res.data?.length)) % 360;
	  				res.data[i].color = `hsl(${hue}, 70%, 60%)`;
				}
			}
			this.setState({
				categories: res.categories || [],
				total: res.total || 0,
				data: res.data || [],
			},() => {
				this.loadChart();
			});
		}
		else if (this.props.tab == TABS.DIGITAL) {
			const res: any = await MoneyService.admin.digital.view({
				user_id: this.props.user?.id,
				...this.state.form
			});
			this.setState({
				total: res.total || 0,
				data: res.data || [],
			},() => {
				this.loadChart();
			});
		}
		else if (this.props.tab == TABS.LIQUIDITY) {
			const res: any = await MoneyService.admin.liquidity.view({
				user_id: this.props.user?.id,
				...this.state.form
			});
			this.setState({
				data: res.data || [],
				total: res.total || 0,
				categories: res.categories || []
			},() => {
				this.loadChart();
			});
		}
	}

	loadChart = () => {
		// @ts-ignore
		this.state.chart?.destroy();

		// @ts-ignore
		this.state.chart_bars?.destroy();

		try {
			this.setState({
				// @ts-ignore
				chart: new Chart(document.getElementById("chart"), {
					type: 'doughnut',
					data: {
						datasets: [{
							data: this.state.data.map((item: any) => item.total_amount),
							backgroundColor: this.state.data.map((item: any) => item.color),
							borderWidth: 0,
						}]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						cutout: '85%',
						plugins: {
							datalabels: {
				                display: false
				            }
						}
					}
				})
			});
		}
		catch(e) { console.log(e) }
		
		try {
			this.setState({
				// @ts-ignore
				chart_bars: new Chart(document.getElementById("chart_bars"), {
					type: 'bar',
					data: {
					  labels: this.state.data.map((item: any) => ''),
					  datasets: [{
			            label: 'Total',
			            data: this.state.data.map((item: any) => item.total_amount),
			            backgroundColor: this.state.data.map((item: any) => item.color),
			            borderRadius: {
			                topLeft: 5,
			                topRight: 5,
			                bottomLeft: 0,
			                bottomRight: 0
			            }
				      }],
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
					    plugins: {
					        legend: {
					            display: false
					        },
					        datalabels: {
					            display: false
					        }
					    },
					    scales: {
					        y: {
					            grid: {
					                color: Colors.gray
					            }
					        },
					        x: {
					            grid: {
					                color: Colors.gray
					            }
					        }
					    }
					},
				}),
			});
		}
		catch(e) { console.log(e) }
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setType = (type: number, callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				type
			}
		},() => callback());
	}
		
	render() {
		const { chart_type, data } = this.state;

		return (
			<div id="modal-view-money">
		          <div className="row container-header">
						<div className="col-8">
							<p>{ this.props.user?.name + ' ' + this.props.user?.lastname }</p>
						</div>
						<div className="col-4 text-right">
							<button className="btn btn-close" onClick={ () => this.props.onClose() }>
								<img src={ CloseIcon } />
							</button>
						</div>
				  </div>
				  <div className="row">
				  	<div className="col-md-6">
				  		<div className="container-gray">
				  			{
				  				chart_type == CHARTS.CIRCLE && (
				  					<>
					  					<div className="container-chart">
									  		<canvas id="chart"></canvas>
									  		<div className="container-total">
												<h3>Total Patrimonio</h3>
												<h4>{ Globals.formatMiles(this.state.total) }</h4>
											</div>
									  	</div>
									  	<a href="#" onClick={ (e: any) => {
									  		e.preventDefault();
									  		this.setState({
									  			chart_type: CHARTS.BARS
									  		},() => this.loadChart());
									  	} }>
									  		<img src={ ArrowRightBlack } />
									  	</a>
								  	</>
				  				)
				  			}
				  			{
				  				chart_type == CHARTS.BARS && (
				  					<>
				  						<a href="#" className="left" onClick={ (e: any) => {
									  		e.preventDefault();
									  		this.setState({
									  			chart_type: CHARTS.CIRCLE
									  		},() => this.loadChart());
									  	} }>
									  		<img src={ ArrowLeftBlack } />
									  	</a>
										<div className="container-bars">
											<div className="container-separator">
											  	<h4>Total <h3>{ Globals.formatMiles(this.state.total) }</h3></h4>
											  	<hr />
											</div>
									  		<canvas id="chart_bars"></canvas>
									  	</div>
				  					</>
				  				)
				  			}
						</div>
				  	</div>
				  	<div className="col-md-6">
						{
							this.props.tab == TABS.DIGITAL && (
								<div className="container-tabs">
									<button 
										className={ `btn ${ this.state.form.type == Constants.MONEY_CATEGORIES.STOCKS ? 'active' : '' }` } 
										style={{ marginRight: '5px' }}
										onClick={ () => this.setType(Constants.MONEY_CATEGORIES.STOCKS,() => this.load()) }>
										<img src={ StocksIcon } />
										Acciones
									</button>
									<button 
										className={ `btn ${ this.state.form.type == Constants.MONEY_CATEGORIES.CRYPTO ? 'active' : '' }` } 
										style={{ marginRight: '5px', marginLeft: '5px' }}
										onClick={ () => this.setType(Constants.MONEY_CATEGORIES.CRYPTO,() => this.load()) }>
										<img src={ CryptosIcon } />
										Criptos
									</button>
									<button 
										className={ `btn ${ this.state.form.type == Constants.MONEY_CATEGORIES.BONDS ? 'active' : '' }` } 
										style={{ marginLeft: '5px' }}
										onClick={ () => this.setType(Constants.MONEY_CATEGORIES.BONDS,() => this.load()) }>
										<img src={ BondsIcon } />
										Bonos
									</button>
								</div>
							)
						}

						{
							(this.props.tab == TABS.PHYSICAL || this.props.tab == TABS.LIQUIDITY) && (
								<Select
									color="white"
									placeholder="Todas las categorías"
									name="category_id"
									onChange={ (e: any) => this.change(e,() => this.load()) }
									value={ this.state.form.category_id }
									options={ this.state.categories?.map((item: any) => {
										return {
											value: item?.id,
											label: item?.name
										}
									}) || [] } />
							)
						}
				  		<table className="table">
				  			<thead>
				  				<tr>
				  					<th>Categoría</th>
				  					<th className="text-right">Monto</th>
				  				</tr>
				  			</thead>
				  			<tbody>
				  				{
				  					data?.map((item: any) => {
				  						return (
				  							<tr>
							  					<td>
							  						<div className="container-color">
							  							<div className="color" style={{ backgroundColor: item?.color }}></div>
							  							<p>{ item?.name }</p>
							  						</div>
							  					</td>
							  					<td className="text-right">
							  						<p className="amount">{ Globals.formatMiles(item?.total_amount) }</p>
							  					</td>
							  				</tr>
				  						)
				  					})
				  				}
				  			</tbody>
				  		</table>
				  	</div>
				  </div>
			</div>
		)
	}
}

export default ModalView;